import { Flex, Text } from '@approvalmax/ui/src/components';
import { memo, useMemo } from 'react';
import { t } from 'services/localization';
import { getCountryCodeByCurrency, getCountryFlagByCountryCode } from 'shared/helpers/(wallets)';

import { WalletTotalAmountProps } from './WalletTotalAmount.types';

export const WalletTotalAmount = memo<WalletTotalAmountProps>((props) => {
    const { walletCurrency, totalAmount } = props;

    const IconFlag = useMemo(
        () => getCountryFlagByCountryCode(getCountryCodeByCurrency(walletCurrency)),
        [walletCurrency]
    );

    return (
        <Flex spacing='8' alignItems='center'>
            <Text font='label' fontSize='medium' color='midnight70'>
                {t('total_amount_1')}
            </Text>

            <Text font='label' fontSize='medium' fontWeight='bold'>
                {totalAmount}
            </Text>

            {IconFlag && <IconFlag width='22px' height='16px' />}
        </Flex>
    );
});

WalletTotalAmount.displayName = 'WalletTotalAmount';
